import { render, staticRenderFns } from "./goodsEvaluationList.vue?vue&type=template&id=d197037e"
import script from "./goodsEvaluationList.vue?vue&type=script&lang=js"
export * from "./goodsEvaluationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports